import { useAppSelector } from '@/hooks/index'
import { Profile } from '@/types/user'
import { Home, Plan, Utility } from '@/types'

export default function useProfileId() {
  return useAppSelector((state) => state.user.user?.profile?.id ?? null)
}

export function useProfile(): Profile | null {
  return useAppSelector((state) => state.user.user?.profile ?? null)
}

/**
 * These three pieces of the profile puzzle are used frequently enough that I
 * wanted to just make a standard hook for them -- AVild
 */
export function useProfileInfo(): {
  profile: Profile | null
  home: Home | null
  utility: Utility | null
  plan: Plan | null
  isLoading: boolean
} {
  const profile = useAppSelector((state) => state.user.user?.profile) ?? null
  const selectedHome =
    useAppSelector((state) => state.homes?.selectedHome) ?? null
  const selectedUtility =
    useAppSelector((state) => state.utilities?.selectedUtility) ?? null
  const selectedPlan =
    useAppSelector((state) => state.plans?.selectedPlan) ?? null

  const fetchingProfile =
    useAppSelector((state) => state.user?.isFetchingUser) ?? true
  const fetchingHome = useAppSelector((state) => state.homes?.isLoading) ?? true
  const fetchingUtility =
    useAppSelector((state) => state.utilities?.isLoading) ?? true
  const fetchingPlan = useAppSelector((state) => state.plans?.isLoading) ?? true

  return {
    profile,
    home: selectedHome,
    utility: selectedUtility,
    plan: selectedPlan,
    isLoading:
      fetchingPlan || fetchingHome || fetchingProfile || fetchingUtility,
  }
}
